/** Pick best preview URL for Brand Library carousel / modal (vectors often have only original). */
export function mediaAssetPreviewUrl(asset) {
  if (!asset) return null;
  const thumb = asset.thumb_url;
  const web = asset.web_url;
  const original = asset.original_url;
  const logo = asset.logo_display_url;
  if (asset.is_vector) {
    return asset.transparent_url || original || logo || web || thumb;
  }
  return thumb || web || original || logo;
}

export function isLogoLikeMediaAsset(asset) {
  if (!asset) return false;
  if (asset.is_vector) return true;
  const name = (asset.file_name || '').toLowerCase();
  const folder = (asset.folder_path || '').toLowerCase();
  return /logo|scmi|selkirk/.test(name) || /logo/.test(folder);
}
